<button
	nz-button
	nzSize="large"
	nz-tooltip="Upload CSVs"
	(click)="nav.navigate(['/', 'my', 'admin', 'setup-wizard', SetupWizardState.UPLOAD_CSVS, clientUuid()])"
>
	<nz-icon nzType="upload" />
</button>
